module.exports = __webpack_public_path__ + "fa9b5884088a113a35c3d7125d9f2952.MP3";